import {Validators}                     from '@angular/forms';
import {ApDynformsConfigPlaceholder}    from '../../../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {ApDynformsConfigNumerictextbox} from '../../../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {ApDynformsConfigComboBox}       from '../../../../ap-dynforms/config/ap-dynforms-config-combobox';
import {ApDynformsValidator}            from '../../../../ap-dynforms/ap-dynforms-validator';
import {nameOf}                         from '../../../../ap-core/utils/ap-name-of';
import IApplicationSettingsParameters = Data.Agronomic.IApplicationSettingsParameters;
import ISlopeConfiguration = Data.Agronomic.ISlopeConfiguration;

/**
 * Base class for n-fertilization ui configuration
 */
export class NAppSettingsConfigBase {
  /**
   * Generates the slope control depending on the application parameter settings
   * @param parameters agronomic parameter settings which applies for field's crop, ec-value, etc...
   * @param values the current form values
   * @param applyBlinkEffect true if the blink effect should be applied on init
   * @protected
   */
  protected generateSlopeControls(parameters: IApplicationSettingsParameters, values: any,
                                  applyBlinkEffect: boolean): ApDynformsConfigPlaceholder | ApDynformsConfigNumerictextbox | ApDynformsConfigComboBox {
    if (parameters?.slopeShown !== true) {
      return new ApDynformsConfigPlaceholder();
    }
    if (parameters?.slopeType === 'numeric') {
      return new ApDynformsConfigNumerictextbox({
        key: 'ControlFactor',
        label: 'Nutrients__ControlFactor_kg_per_kg_N_uptake',
        infoText: 'Information__Variation_Factor',
        value: values['ControlFactor'],
        step: 0.1,
        min: -8,
        max: 8,
        disabled: !parameters.slopeShown,
        blinkOnInit: applyBlinkEffect,
        validators: [
          new ApDynformsValidator({validator: Validators.required, errorKey: ''}),
        ]
      });
    } else if (parameters?.slopeType === 'dropDown') {
      return new ApDynformsConfigComboBox({
        key: 'ControlFactor',
        label: 'Fertilisation__ControlCurve',
        options: parameters.slope,
        textField: nameOf<ISlopeConfiguration>('Key'),
        valueField: nameOf<ISlopeConfiguration>('Slope'),
        translate: true,
        value: values['ControlFactor'] ?? parameters?.slope?.FirstOrDefault()?.Slope,
        blinkOnInit: applyBlinkEffect,
        validators: [
          new ApDynformsValidator({validator: Validators.required, errorKey: ''}),
        ]
      });
    }
    return new ApDynformsConfigPlaceholder();
  }
}
